import React from 'react';

const ScreenActivityIndicator = (props) => {
    const { margin = 150 } = props;

    return (
        <div className="zb-loader-block">
            <div className="zb-loader-content" style={{ marginTop: margin, marginBottom: margin }}>
                <span className="zb-loader" />
                <span className="zb-loader-text">Loading form</span>
            </div>
        </div>
    );
};

export default ScreenActivityIndicator;